import { FC, useRef } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { useTeamChatSelector } from '../../providers/team-chat.provider/team-chat.provider';
import { AttachmentFilter } from './filters/attachment-filter.component';
import { ChannelFilter } from './filters/channel-filter.component';
import { SenderFilter } from './filters/sender-filter.component';
import { SearchBar, SearchBarRef } from './search-bar.component';

export const KeywordSearchWithFilters: FC = () => {
  const searchBarRef = useRef<SearchBarRef>(null);
  const isNavExpanded = useTeamChatSelector((ctx) => ctx.isNavExpanded);

  const focusSearchBar = () => {
    setTimeout(() => {
      searchBarRef.current?.focus();
    }, 300);
  };

  return (
    <div css={styles.container}>
      <SearchBar ref={searchBarRef} />
      <div css={styles.filtersContainer(isNavExpanded)}>
        <ChannelFilter focusSearchBar={focusSearchBar} />
        <SenderFilter focusSearchBar={focusSearchBar} />
        <AttachmentFilter focusSearchBar={focusSearchBar} />
      </div>
    </div>
  );
};

const styles = {
  container: css({
    padding: theme.spacing(0.5, 1, 0, 1),
  }),
  filtersContainer: (isNavExpanded: boolean) =>
    css({
      display: 'flex',
      gap: theme.spacing(1),
      marginTop: theme.spacing(1.5),
      width: '100%',
      overflow: 'hidden',

      ...(isNavExpanded && {
        flexWrap: 'wrap',
      }),

      '> div': {
        ...(!isNavExpanded && {
          flex: 1,
        }),
        maxWidth: isNavExpanded ? '100%' : 'calc(100% / 3)',
        width: isNavExpanded ? '100%' : 'fit-content',
      },

      '.dropdownFilterChipField': {
        outline: 'none',
        height: '24px',
        width: '100%',
        justifyContent: 'space-between',

        svg: {
          width: theme.spacing(1),
          height: theme.spacing(1),
        },

        p: {
          fontSize: theme.font.size.small,
        },
      },
      '.dropdownFilterChipField.has-value p': {
        fontWeight: theme.font.weight.bold,
      },
      '.dropdownFilterChipField[aria-expanded="true"]': {
        borderColor: theme.colorsV2.blue50(),
      },
    }),
};
